//Stores
import { get, writable } from 'svelte/store';
//Services
import { format } from 'svelte-i18n';
//Types
import type { Writable } from 'svelte/store';
import type { DeviceNotification } from 'src/helpers/notifications/DeviceNotification';

export const _format = get(format);

export const device_notifications: Writable<{
	[category: string]: DeviceNotification;
}> = writable({});

const create_dismissible_notifications = () => {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('dismissed_notifications')) || {},
	);
	return {
		subscribe,
		dismiss: (id) =>
			update((ids) => {
				const time = +(new Date().getTime() / 1000).toFixed(0);
				ids[id] = time;
				return ids;
			}),
		remove: (id) =>
			update((ids) => {
				delete ids[id];
				return ids;
			}),
	};
};

export const dismissed_notifications = create_dismissible_notifications();

dismissed_notifications.subscribe((val) =>
	localStorage.setItem('dismissed_notifications', JSON.stringify(val)),
);

const create_additional_notifications = () => {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('additional_notifications')) || {},
	);

	return {
		subscribe,
		add: (id, notification) =>
			update((ids) => {
				if (!ids[id]) {
					ids[id] = [];
				}
				ids[id].push(notification);
				return ids;
			}),
		remove: (id, notificationName) =>
			update((ids) => {
				if (ids?.[id]) {
					// Filter out the notification with the given name
					ids[id] = ids[id].filter((notif) => notif.name !== notificationName);

					// If the array is empty, remove the key
					if (ids[id].length === 0) {
						delete ids[id];
					}
				}
				return ids;
			}),
		clear: () => set({}), // Clears all notifications
	};
};

export const additional_notifications = create_additional_notifications();

additional_notifications.subscribe((val) =>
	localStorage.setItem('additional_notifications', JSON.stringify(val)),
);

const create_read_notifications = () => {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('read_notifications')) || {},
	);
	return {
		subscribe,
		set,
		read: (profileID: number, notificationID: string) =>
			update((ids) => {
				ids[profileID] = { ...(ids[profileID] || {}), [notificationID]: true };
				return ids;
			}),
		unread: (profileID: number, notificationID: string) =>
			update((ids) => {
				if (ids[profileID]) {
					delete ids[profileID][notificationID];
				}
				return ids;
			}),
		unreadAll: (profileID: number) => {
			update((ids) => {
				ids[profileID] = {};
				return ids;
			});
		},
	};
};

export const read_notifications = create_read_notifications();

read_notifications.subscribe((val) => localStorage.setItem('read_notifications', JSON.stringify(val)));
